import {experiment, editorDataFunction} from '../../../editorUtils/editorDataResolver';

export const SignatureInputMetadata = {
  allowConnectToDB: editorDataFunction(experiment('specs.wixData.SignatureInput'), isOpen => isOpen),
};
